import {
    ResetWidgetInstancesState,
    WidgetActionType,
    WidgetTypeAction,
    WidgetTypeActionPayload,
} from 'widgets/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import { Reducer } from 'redux';
import { WidgetState } from 'widgets/store/WidgetsState';
import { Action } from 'store/store';
import { didNotReduce } from 'utils/redux/utils';

export function createWidgetsReducer<
    TState,
    TPayload extends WidgetTypeActionPayload,
    TActionType extends string = WidgetActionType,
>(
    widgetType: WidgetType,
    widgetStateReducer: Reducer<
        TState,
        WidgetTypeAction<TPayload, TActionType> | ResetWidgetInstancesState
    >
): Reducer<WidgetState<TState>, WidgetTypeAction<TPayload, TActionType>> {
    const initialWidgetState = widgetStateReducer(
        undefined,
        {} as WidgetTypeAction<TPayload, TActionType>
    );
    return (
        state: WidgetState<TState> = {},
        action: Action<string, Partial<TPayload> | undefined>
    ) => {
        if (action.type === WidgetActionType.WIDGET_RESET_INSTANCES_STATE) {
            return {};
        }

        if (
            !action.payload ||
            !action.payload.widgetKey ||
            !action.payload.widgetType ||
            action.payload!.widgetType !== widgetType
        ) {
            return state;
        }

        const prevWidgetState =
            state[action.payload!.widgetKey] || initialWidgetState;

        const nextWidgetState = widgetStateReducer(
            prevWidgetState,
            action as WidgetTypeAction<TPayload, TActionType>
        );

        if (didNotReduce(prevWidgetState, nextWidgetState)) {
            return state;
        }

        return {
            ...state,
            [action.payload!.widgetKey]: nextWidgetState,
        };
    };
}
